var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mapboxgl-ctrl-group mapboxgl-ctrl"},[_c('v-btn',{staticClass:"white px-0",attrs:{"href":"#","height":"29px","width":"29px","min-width":"29px"},on:{"click":function($event){$event.preventDefault();return _vm.toggleSatellite.apply(null, arguments)}}},[_c('v-icon',[_vm._v("mdi-layers")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }